import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import type { ShowErrorFlag } from '@helpcenter/flags';
import { showErrorFlag } from '@helpcenter/flags';
import fetchModel from 'epics/model/fetcher';
import type { FetchLanguagesAction, FetchLanguagesSuccess } from 'state/actions/languages';
import { FETCH_LANGUAGES_MODEL, fetchLanguagesSuccess } from 'state/actions/languages';
import { genericError } from 'utils/errors';
import type { ErrorResponse } from 'epics/model/types';

export const languagesEpic: Epic<FetchLanguagesAction, FetchLanguagesSuccess | ShowErrorFlag> = (
	action$,
) => {
	return action$.ofType(FETCH_LANGUAGES_MODEL).mergeMap((action) =>
		fetchModel(action.payload)
			.filter((response) => !!response.availableLanguages)
			.map((response) => {
				return fetchLanguagesSuccess(response.availableLanguages || []);
			})
			.catch((_: ErrorResponse) => {
				return Observable.of(showErrorFlag(genericError.title, genericError.description));
			}),
	);
};
